<div class="page-content bg-white">
  <!-- inner page banner -->
  <!-- <div class="dez-bnr-inr overlay-black-middle" style="background-image:url('/assets/images/bg4.jpg');">
    <div class="container">
      <div class="dez-bnr-inr-entry">
        <h1 class="text-white">Contactenos</h1>
      </div>
    </div>
  </div> -->
  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>Contactenos</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <!-- Career -->
    <div class="container">
      <div class="row">
        <!-- Left part start -->
        <div class="col-md-9 m-b30">
          <h1 class="m-b20 m-t0">Contactenos</h1>
          <div class="dez-separator bg-primary"></div>
          <div id="Stellar_video_player"></div>
        </div>
        <!-- Left part start END -->
        <div class="col-md-12">
          <div class="widget bg-white recent-posts-entry">
            <div class="widget-post-bx">
              <div class="authors">
                <ul class="list-unstyled">
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cuál es la Misión? </h4>

                        <div itemprop="description">
                          "Dirigir la Planificación Integral del Estado Plurinacional, hacia el logro de los objetivos
                          del Desarrollo Integral para Vivir Bien en armonía con la Madre Tierra, en el marco de la
                          Agenda Patriótica 2025”. </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cuál es la Visión? </h4>

                        <div itemprop="description">
                          “El Ministerio de Planificación del Desarrollo es un gestor y articulador de los objetivos del
                          desarrollo del Vivir Bien en armonía con la Madre Tierra, que apoya a las entidades del Estado
                          en la planificación de la gestión pública plurinacional, aplicando políticas, estrategias e
                          instrumentos de planificación integral estatal, inversión pública y financiamiento,
                          fortaleciendo el rol del Estado y de los actores de la economía plural”. </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cuáles y cuántos son los Viceministerios que dependen del Ministerio de Planificación del
                          Desarrollo? </h4>

                        <div itemprop="description">
                          Los siguientes tres Viceministerios dependen del Ministerio:
                          <ul>
                            <li>Viceministerio de Inversión Pública y Financiamiento Externo</li>
                            <li>Viceministerio de Planificación Estratégica del Estado</li>
                            <li>Viceministerio de Planificación y Coordinación </li>
                          </ul>
                        </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cuáles son las entidades bajo tuición del Ministerio de Planificación del Desarrollo? </h4>

                        <div itemprop="description">
                          Entidades:
                          <ul class="list-group">
                            <li>Instituto Nacional de Estadística – INE</li>
                            <li>Unidad de Análisis de Políticas Sociales y Económicas – UDAPE</li>
                            <li>Banco de Desarrollo Productivo – BDP</li>
                            <li>Agencia para el Desarrollo de las Macroregiones y Zonas Fronterizas – ADEMAF</li>
                            <li>Proyecto de Manejo de Recursos Naturales -PROMARENA</li>
                            <li>Fondo Nacional de Desarrollo Regional – FNDR</li>
                            <li>Fondo de Desarrollo del Sistema Financiero y Apoyo al Sector Publico – FONDESIF</li>
                            <li>Fondo Nacional de Inversión Productiva y Social – FPS </li>
                          </ul>
                        </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cuáles son los horarios de atención para dejar correspondencia? </h4>

                        <div itemprop="description">
                          Los horarios de atención por la mañana son de horas 8:30 a 12:00 y de 14:30 a 18:00 por las
                          tardes. </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Dónde encuentro el Plan Nacional de Desarrollo? </h4>

                        <div itemprop="description">
                          El Plan Nacional de Desarrollo se la puede encontrar en la página principal del ministerio en
                          versión pdf, mismo que se puede imprimir.<br> <a
                            href="http://www.planificacion.gob.bo/pdes/pdes2016-2020.pdf">Ir al documento</a> </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item animated fast fadeIn" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix animated fast fadeIn" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cómo encuentro información acerca de convocatorias de empleo? </h4>

                        <div itemprop="description">
                          Las convocatorias de empleo se muestran en la página web, ingresando al menú transparencia y
                          al submenú contrataciones, convocatorias, en la que podrá encontrar información acerca de las
                          consultorías recientes y pasadas. <br>
                          <a routerLink="/content/1467">Ir a la sección</a>
                        </div>
                      </div>
                    </aside>
                  </li>
                  <li class="post-item" data-showonscroll="true" data-animation="fadeIn">
                    <aside class="author-box clearfix" itemprop="author" itemscope=""
                      itemtype="http://schema.org/Person" data-showonscroll="true" data-animation="fadeIn">

                      <div class="box-content clearfix">
                        <h4 class="name">
                          ¿Cuáles son las últimas publicaciones de boletines en la página Web del MPD? </h4>

                        <div itemprop="description">
                          Las últimas publicaciones de boletines se encuentran en nuestra página web en la portada,
                          todas ellas en un formato digital que permite su lectura y descarga. </div>
                      </div>
                    </aside>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
        <!-- Right part start -->

        <!-- Right part start END -->
      </div>
    </div>
    <!-- Career END -->
  </div>
  <!-- contact area END -->
</div>


// WEBPACK FOOTER //
// ./src/app/layouts/faq/faq.component.html